var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Card } from '@philips-internal/oswald-ui-components';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { eventListener } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import moment from 'moment';
import React, { Component } from 'react';
import PhysicianScheduleCardBlockAPI from './physician-schedule-card-block-api';
let PhysicianScheduleCardBlock = class PhysicianScheduleCardBlock extends Component {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            const { blockingReasonType, classificationBlockType, createdDate, createdUser, daysAdvanceQuantity, dayWeekType, doctorCode, endBlockingHour, finalDate, initialDate, internalObservationDescription, noteDescription, onClick, reasonScheduleBlockSequence, requestDate, scheduleBlockQuantity, scheduleCode, sequenceNumber, shortDescription, startBlockingHour, updatedDate, updatedUser, } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        blockingReasonType,
                        classificationBlockType,
                        createdDate,
                        createdUser,
                        daysAdvanceQuantity,
                        dayWeekType,
                        doctorCode,
                        endBlockingHour,
                        finalDate,
                        initialDate,
                        internalObservationDescription,
                        noteDescription,
                        onClick,
                        reasonScheduleBlockSequence,
                        requestDate,
                        scheduleBlockQuantity,
                        scheduleCode,
                        sequenceNumber,
                        shortDescription,
                        startBlockingHour,
                        updatedDate,
                        updatedUser,
                    }
                }));
            }
        };
    }
    static { this.propTypes = {
        onClick: eventListener
    }; }
    renderIndicatorColorStatus() {
        const { finalDate, endBlockingHour } = this.props;
        const timeEnd = endBlockingHour ? moment(endBlockingHour) : moment().endOf('day');
        const endDateStatus = moment(finalDate).hour(timeEnd.hour()).minute(timeEnd.minute());
        const statusColor = moment().isSameOrBefore(endDateStatus, 'minute') ? 'c-physician-schedule-card__done' : 'c-physician-schedule-card__canceled';
        return (React.createElement("div", { className: `c-physician-schedule-card__indicator-color ${statusColor}` }));
    }
    formatStartTime(startDate, startTime, endDate, endTime) {
        return `${startDate} ${startTime} - ${endDate} ${endTime}`;
    }
    renderContent() {
        const { endBlockingHour, finalDate, initialDate, startBlockingHour, shortDescription, noteDescription } = this.props;
        const starTime = startBlockingHour ? moment(String(startBlockingHour)).format(' LT') : '';
        const endTime = endBlockingHour ? moment(String(endBlockingHour)).format(' LT') : '';
        const endDate = moment(String(finalDate)).format('L ');
        const startDate = moment(String(initialDate)).format('L ');
        return (React.createElement("div", { className: 'c-physician-schedule-card__content' },
            React.createElement("div", { className: 'c-physician-schedule-card__content-left' },
                React.createElement("span", { className: 'c-physician-schedule-card-title' }, shortDescription),
                React.createElement("span", { className: 'c-physician-schedule-card-title' }, noteDescription),
                React.createElement("span", null, this.formatStartTime(startDate, starTime, endDate, endTime)))));
    }
    renderField() {
        return (React.createElement(React.Fragment, null,
            this.renderIndicatorColorStatus(),
            this.renderContent()));
    }
    render() {
        const legends = [
            {
                color: 'signal-green-45',
                label: MessageService.translate('tws.date-within-term'),
                value: MessageService.translate('tws.date-within-term')
            },
            {
                color: 'signal-red-45',
                label: MessageService.translate('tws.date-out-term'),
                value: MessageService.translate('tws.date-out-term')
            },
        ];
        const { scheduleCode, sequenceNumber } = this.props;
        return (React.createElement(Card, { className: 'c-physician-schedule-card', onClick: () => this.handleClick(), selectionType: SelectionType.SINGLE, superscription: legends, uuid: generateUUID(), key: `${scheduleCode} + ${sequenceNumber}`, width: 12 }, this.renderField()));
    }
};
PhysicianScheduleCardBlock = __decorate([
    AwesomeComponent({ api: PhysicianScheduleCardBlockAPI, type: ComponentType.DATA_DISPLAY })
], PhysicianScheduleCardBlock);
export default PhysicianScheduleCardBlock;
//# sourceMappingURL=physician-schedule-card-block.js.map